import React from 'react';

import { Link } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import error403 from '../../images/403.svg';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    
    img {
        margin-bottom: 40px;
    }
`;

const TextContainer = styled.div`
    margin-bottom: 40px;
`;

const ErrorMessage = styled.div`
    text-align: center;

    a {
        text-decoration: none;
        border-bottom: 1px solid ${(props) => props.theme.colors.primary.main};
    }
`;

const StrongErrorMessage = styled(ErrorMessage)`
    font-weight: bold;
    margin-bottom: 5px;
`;

const SUPPORT_LINK = 'https://classedu.secure.force.com/CreateCase/apex/b3f__formcomplete?id=a1k4W000004uu5NQAQ&CaseId=[XXXXX]';
const KNOWLEDGE_LINK = 'https://www.class.com/knowledge-base/updating-zoom-marketplace-permissions-for-class/';

const RosterPermissionsError: React.FC = () => {
    const { t } = useTranslation('roster');

    return (
        <Container>
            <img src={error403} alt={'403 error image'}/>
            <TextContainer>
                <StrongErrorMessage>{t('roster-permissions')}</StrongErrorMessage>
                <ErrorMessage>
                    <Trans i18nKey={'roster:permissions-generic-1'}>
                        You may need to update Class permissions in Zoom. <Link href={KNOWLEDGE_LINK} title={t('knowledge-link')} target='_blank' rel='noreferrer'>Please visit our knowledge base for more information.</Link>
                    </Trans>
                </ErrorMessage>
                <ErrorMessage>
                    <Trans i18nKey={'roster:permissions-generic-2'}>
                        If you continue to experience issues after updating your permissions, <Link href={SUPPORT_LINK} title={t('support-link')} target='_blank' rel='noreferrer'>please contact customer support</Link> or your Class administrator.
                    </Trans>
                </ErrorMessage>
            </TextContainer>
        </Container>
    );
};

export default RosterPermissionsError;
